import { format, isAfter, isToday, isYesterday, subDays } from "date-fns";
import type { Locale } from "date-fns";

export const formatMessageDate = (lastMessageAt: Date | null, locale: Locale) => {
  if (!lastMessageAt) {
    return " ";
  }
  if (isToday(lastMessageAt)) {
    return format(lastMessageAt, "p", { locale });
  } else if (isYesterday(lastMessageAt)) {
    return "Yesterday"; // todo translation i18n
  } else if (isAfter(lastMessageAt, subDays(new Date(), 4))) {
    return format(lastMessageAt, "EEEE", { locale });
  }

  return format(lastMessageAt, "PP", { locale });
};
